'use client';

import Footer from '../global/partials/Footer';
import { PageHowItWorksSchema } from '@/sanity/pages/PageHowItWorksTemplate';
import HeroSection from '../pageComponents/how-it-works/HeroSection';
import StepSection from '../pageComponents/how-it-works/StepSection';
import ProfitSliderSection from '../pageComponents/global/sections/ProfitSliderSection';
import InstantFundingSection from '../pageComponents/how-it-works/InstantFundingSection';
import FaqSection from '../pageComponents/global/sections/FaqSection';
import HeaderV2 from '../global/partials/HeaderV2';

export default function PageHowItWorksJSX({
  data,
}: {
  data: PageHowItWorksSchema;
}) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={'main'} // showBorder
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <StepSection
        stepLabel={data.evaluationStepLabel}
        title={data.evaluationTitle}
        features={data.evaluationFeatures}
        button={data.evaluationButton}
      />
      <ProfitSliderSection data={data} />
      <StepSection
        stepLabel={data.fundedStepLabel}
        title={data.fundedTitle}
        features={data.fundedFeatures}
        button={data.fundedButton}
      />
      <InstantFundingSection data={data} />
      <StepSection
        stepLabel={data.eliteStepLabel}
        title={data.eliteTitle}
        features={data.eliteFeatures}
        button={data.eliteButton}
      />
      <FaqSection className="lg:py-[16rem]" data={data} />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
